import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Subtract">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23202 1.35364C7.09874 0.486919 8.27427 0 9.5 0C10.7257 0 11.9013 0.486919 12.768 1.35364C13.6347 2.22036 14.1216 3.39589 14.1216 4.62162C14.1216 5.84735 13.6347 7.02288 12.768 7.8896C11.9013 8.75632 10.7257 9.24324 9.5 9.24324C8.27427 9.24324 7.09874 8.75632 6.23202 7.8896C5.3653 7.02288 4.87838 5.84735 4.87838 4.62162C4.87838 3.39589 5.3653 2.22036 6.23202 1.35364ZM9.5 1.80372C8.75264 1.80372 8.0359 2.1006 7.50744 2.62906C6.97898 3.15752 6.68209 3.87427 6.68209 4.62162C6.68209 5.36898 6.97898 6.08572 7.50744 6.61418C8.0359 7.14264 8.75264 7.43953 9.5 7.43953C10.2474 7.43953 10.9641 7.14264 11.4926 6.61418C12.021 6.08572 12.3179 5.36898 12.3179 4.62162C12.3179 3.87427 12.021 3.15752 11.4926 2.62906C10.9641 2.1006 10.2474 1.80372 9.5 1.80372Z"
        fill="#222A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15.598C0 14.8812 0.356999 14.2344 0.983956 13.6558C1.61266 13.0755 2.49558 12.5813 3.49598 12.1806C5.49721 11.3789 7.90394 10.9764 9.5 10.9764C11.0961 10.9764 13.5028 11.3789 15.504 12.1806C16.5044 12.5813 17.3873 13.0755 18.016 13.6558C18.643 14.2344 19 14.8812 19 15.598V19H0V15.598ZM9.5 12.7801C7.65083 12.7801 5.75939 13.2336 4.32952 13.7851C3.61465 14.0609 3.00593 14.3646 2.57097 14.655C2.35424 14.7996 2.17205 14.9467 2.04104 15.0917C1.91747 15.2285 1.80372 15.4026 1.80372 15.598V17.1963H17.1963V15.598C17.1963 15.4026 17.0825 15.2285 16.959 15.0917C16.8279 14.9467 16.6458 14.7996 16.429 14.655C15.9941 14.3646 15.3854 14.0609 14.6705 13.7851C13.2406 13.2336 11.3492 12.7801 9.5 12.7801Z"
        fill="#222A5C"
      />
      <path
        d="M4.32952 13.7851C5.75939 13.2336 7.65083 12.7801 9.5 12.7801C11.3492 12.7801 13.2406 13.2336 14.6705 13.7851C15.3854 14.0609 15.9941 14.3646 16.429 14.655C16.6458 14.7996 16.8279 14.9467 16.959 15.0917C17.0825 15.2285 17.1963 15.4026 17.1963 15.598V17.1963H1.80372V15.598C1.80372 15.4026 1.91747 15.2285 2.04104 15.0917C2.17205 14.9467 2.35424 14.7996 2.57097 14.655C3.00593 14.3646 3.61465 14.0609 4.32952 13.7851Z"
        fill="#222A5C"
      />
      <path
        d="M7.50744 2.62906C8.0359 2.1006 8.75264 1.80372 9.5 1.80372C10.2474 1.80372 10.9641 2.1006 11.4926 2.62906C12.021 3.15752 12.3179 3.87427 12.3179 4.62162C12.3179 5.36898 12.021 6.08572 11.4926 6.61418C10.9641 7.14264 10.2474 7.43953 9.5 7.43953C8.75264 7.43953 8.0359 7.14264 7.50744 6.61418C6.97898 6.08572 6.68209 5.36898 6.68209 4.62162C6.68209 3.87427 6.97898 3.15752 7.50744 2.62906Z"
        fill="#222A5C"
      />
    </g>
  </svg>,
  "PersonFilled"
);
